import React, { memo, useCallback } from "react";
import { ReactSVG } from "react-svg";

import { SummarySectionProps } from "../types";

/** Sekcija pregleda: ikona, naslov s brojem stavki, "Uredi" na korak i sadržaj ili prazno stanje. */
const SummarySection: React.FC<SummarySectionProps> = (props) => {
  const { title, count, icon, stepLabel, onEditStep, emptyText, children } = props;

  const handleEditClick = useCallback(() => {
    onEditStep(stepLabel);
  }, [onEditStep, stepLabel]);

  return (
    <div className="flex flex-col rounded-sm border border-slate-200 bg-white p-4">
      <div className="flex items-center gap-3">
        <span className="flex items-center justify-center w-9 h-9 rounded-sm bg-slate-100 flex-shrink-0">
          <ReactSVG src={icon} className="w-4 h-4 stroke-slate-600" />
        </span>
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <h3 className="text-sm font-semibold text-slate-800">{title}</h3>
          <span className="px-1.5 py-0.5 rounded-full bg-slate-100 text-[0.65rem] font-semibold text-slate-500">
            {count}
          </span>
        </div>
        <button
          type="button"
          onClick={handleEditClick}
          className="text-xs font-semibold text-blue-600 hover:text-blue-800"
        >
          Uredi
        </button>
      </div>

      <div className="mt-3 flex-1">
        {count === 0 ? (
          <div className="flex items-center justify-center h-full min-h-[3rem] rounded-sm border border-dashed border-slate-200 text-xs text-slate-400">
            {emptyText}
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default memo(SummarySection);
